import React, { useState, useEffect } from "react";
import styles from "./line-detail-modal.module.css";
import { getBudgetLineById } from "../../services/apiService";

const LineDetailModal = ({ isOpen, onClose, lineId }) => {
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (!isOpen || !lineId) return;

    let mounted = true;
    const load = async () => {
      setLoading(true);
      try {
        const data = await getBudgetLineById(lineId);
        if (!mounted) return;
        setDetails(data || null);
      } catch (err) {
        console.error("Error loading line details:", err);
        setDetails(null);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    load();

    return () => {
      mounted = false;
    };
  }, [isOpen, lineId]);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h3 className={styles.title}>Detalles de la línea</h3>
          <button className={styles.closeButton} onClick={onClose}>✕</button>
        </div>

        <div className={styles.content}>
          {loading ? (
            <div className={styles.loading}>Cargando...</div>
          ) : (
            <>
              <label className={styles.label}>Trabajos a realizar</label>
              <textarea
                readOnly
                className={styles.textarea}
                value={details?.infoTrabajo || ""}
                placeholder="Sin información"
                spellCheck="true"
              />
            </>
          )}
        </div>

        <div className={styles.actions}>
          <button className={styles.primary} onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
};

export default LineDetailModal;
